import React from 'react';

const Logo = ({ className }) => (
  <svg 
    viewBox="0 0 294.29 500" 
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#04b53a"
      d="M142.54,2.06C65.29,2.06,2.44,64.9,2.44,142.15v89.2H151.75c77.25,0,140.1-62.84,140.1-140.09V2.06Zm125.62,89.2A116.54,116.54,0,0,1,151.75,207.67H33.38q3.18-6.19,6.77-12.14a195.5,195.5,0,0,1,53.54-58.72c14.24-10.66,30.2-18.82,46.74-25.41a235,235,0,0,1,25.47-8.14A216.8,216.8,0,0,1,192.19,98a1.34,1.34,0,0,0,1-.79,1.31,1.31,0,0,0-.7-1.72l-.63-.28a76.57,76.57,0,0,0-14.6-4.58,104.38,104.38,0,0,0-14.89-2.08,126.25,126.25,0,0,0-29.86,1.76,137.12,137.12,0,0,0-55.29,23.84A134.33,134.33,0,0,0,54.7,134.75a108.75,108.75,0,0,0-9.41,12c-1.44,2.09-2.85,4.2-4.15,6.37s-2.5,4.42-3.72,6.62A116.74,116.74,0,0,0,27,188c-.31,1.43-.59,2.86-.84,4.3V142.15A116.54,116.54,0,0,1,142.54,25.74H268.16Z"
    />
    <path
      fill="#04b53a"
      d="M151.75,268.65H2.44v89.2c0,77.25,62.85,140.09,140.1,140.09H291.85v-89.2C291.85,331.49,229,268.65,151.75,268.65ZM268.16,474.26H142.54A116.54,116.54,0,0,1,26.13,357.85V307.69c.25,1.44.53,2.87.84,4.3a116.74,116.74,0,0,0,10.45,28.29c1.22,2.2,2.41,4.45,3.72,6.62s2.71,4.28,4.15,6.37a108.75,108.75,0,0,0,9.41,12,134.33,134.33,0,0,0,22.55,20.59,137.12,137.12,0,0,0,55.29,23.84,126.25,126.25,0,0,0,29.86,1.76,104.38,104.38,0,0,0,14.89-2.08,76.57,76.57,0,0,0,14.6-4.58l.63-.28a1.31,1.31,0,0,0,.7-1.72,1.34,1.34,0,0,0-1-.79,216.8,216.8,0,0,1-26.29-5.25,235,235,0,0,1-25.47-8.14c-16.54-6.59-32.5-14.75-46.74-25.41a195.5,195.5,0,0,1-53.54-58.72q-3.6-5.94-6.77-12.14H151.75A116.54,116.54,0,0,1,268.16,408.74Z"
    />
  </svg>
);

export default Logo;